// extracted by mini-css-extract-plugin
module.exports = {"manaCurve":"legacyStats_manaCurve__lWvWv","deckInfo":"legacyStats_deckInfo__q74ur","infoContent":"legacyStats_infoContent__JkJaJ"};